import Zone from './Zone.vue'

export default Zone



// WEBPACK FOOTER //
// ./node_modules/gvue/src/core/Zone/index.js